import axios from "../utils/axios";

export function getCustomerRules() {
  return axios.get("/CustomerRule/GetCustomerRules");
}
